import { Button, Switch } from "antd";
import type { ColumnsType } from "antd/es/table";
import dayjs from 'dayjs';
import { FormConfigType } from "../../../components/editForm";
import { langPage, langCommon, langTableColumns } from "../../../locales";
import { SettingsServer } from "./../../../server";

const server = SettingsServer.Email

const lang = langPage?.settings?.config;


export const generateTableColumns = (props: any): ColumnsType => {
    const { operationRef, setLoading, refresh } = props;

    return [
        {
            title: "发件箱地址",
            dataIndex: "OutboxAddr",
        },
        {
            title: "发件箱地址密码",
            dataIndex: "OutboxPwd",
        },
        {
            title: "smtp服务地址",
            dataIndex: "SmtpHost",
        },
        {
            title: "smtp服务端口",
            dataIndex: "SmtpPort",
        },
        {
            title: langTableColumns?.operation,
            dataIndex: "ops",
            width: 100,
            fixed: "right",
            render: (_: any, row: any) => {
                return (
                    <div>
                        <Button size="small" type="link" className="pdl0"
                            onClick={() => operationRef?.current?.changeVisible({
                                ...row,
                            }, 'modify')}
                        >{langCommon?.modify}</Button>
                    </div>
                )
            }
        }
    ]
}

export const generateOperationFormConfig = (props: any): FormConfigType | any => {
    return [
        {
            title: "发件箱地址",
            type: "input",
            field: "OutboxAddr",
            allowClear: true,
            rules: [{
                required: true,
                message: `请输入发件箱地址`
            }]
        },
        {
            title: "发件箱地址密码",
            type: "input",
            field: "OutboxPwd",
            allowClear: true,
            rules: [{
                required: true,
                message: `请输入发件箱地址密码`
            }]
        },
        {
            title: "smtp服务地址",
            type: "input",
            field: "SmtpHost",
            allowClear: true,
            rules: [{
                required: true,
                message: `请输入smtp服务地址`
            }]
        },
        {
            title: "smtp服务端口",
            type: "input",
            field: "SmtpPort",
            allowClear: true,
            rules: [{
                required: true,
                message: `请输入smtp服务端口`
            }]
        },
    ];
}